export default __webpack_public_path__ + "static/media/photoframe.3bc663f0.jpg";